module.exports = __webpack_public_path__ + "static/img/logo.cc5638f6.png";